import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 0.5C2.33696 0.5 1.70107 0.763392 1.23223 1.23223C0.763392 1.70107 0.5 2.33696 0.5 3V11.3335V13C0.5 13.663 0.763392 14.2989 1.23223 14.7678C1.70107 15.2366 2.33696 15.5 3 15.5H13C13.663 15.5 14.2989 15.2366 14.7678 14.7678C15.2366 14.2989 15.5 13.663 15.5 13V9.66748V9.66585V3C15.5 2.33696 15.2366 1.70107 14.7678 1.23223C14.2989 0.763392 13.663 0.5 13 0.5H3ZM8.10092 6.92241L9.66667 8.48816L10.3992 7.75565C10.868 7.28698 11.5038 7.02369 12.1667 7.02369C12.7832 7.02369 13.3762 7.25142 13.8333 7.66029V3C13.8333 2.77899 13.7455 2.56702 13.5893 2.41074C13.433 2.25446 13.221 2.16667 13 2.16667H3C2.77899 2.16667 2.56702 2.25446 2.41074 2.41074C2.25446 2.56702 2.16667 2.77899 2.16667 3V9.32149L4.56583 6.92232C5.03465 6.45364 5.67042 6.19036 6.33333 6.19036C6.99624 6.19036 7.6321 6.45373 8.10092 6.92241ZM9.66667 3.83333C9.20643 3.83333 8.83333 4.20643 8.83333 4.66667C8.83333 5.1269 9.20643 5.5 9.66667 5.5H9.675C10.1352 5.5 10.5083 5.1269 10.5083 4.66667C10.5083 4.20643 10.1352 3.83333 9.675 3.83333H9.66667Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}